import { z } from 'zod';

export const ConsumerCheckoutChecklistItemSchema = z.object({
  itemKey: z.string().min(1),
  label: z.string().min(1),
  checked: z.boolean(),
  notes: z.string().nullable(),
});
export type ConsumerCheckoutChecklistItem = z.infer<typeof ConsumerCheckoutChecklistItemSchema>;

export const ConsumerCheckoutChecklistPhotoSchema = z.object({
  id: z.uuid(),
  url: z.string().min(1),
  kind: z.string().min(1),
  mediaType: z.enum(['IMAGE', 'VIDEO']).default('IMAGE'),
  contentType: z.string().min(1).nullable().default(null),
});
export type ConsumerCheckoutChecklistPhoto = z.infer<typeof ConsumerCheckoutChecklistPhotoSchema>;

export const ConsumerCheckoutChecklistDecisionSchema = z.enum(['APPROVED', 'REJECTED']);
export type ConsumerCheckoutChecklistDecision = z.infer<
  typeof ConsumerCheckoutChecklistDecisionSchema
>;

export const ConsumerCheckoutChecklistListItemSchema = z.object({
  serviceOrderId: z.uuid(),
  tenantId: z.uuid(),
  partyId: z.uuid(),
  workshopName: z.string().min(1),
  vehiclePlate: z.string().nullable(),
  vehicleLabel: z.string().nullable(),
  awaitingCustomerApprovalAt: z.string().min(1),
});
export type ConsumerCheckoutChecklistListItem = z.infer<
  typeof ConsumerCheckoutChecklistListItemSchema
>;

export const ConsumerCheckoutChecklistsResponseSchema = z.object({
  items: z.array(ConsumerCheckoutChecklistListItemSchema),
});
export type ConsumerCheckoutChecklistsResponse = z.infer<
  typeof ConsumerCheckoutChecklistsResponseSchema
>;

export const ConsumerCheckoutChecklistDetailSchema = ConsumerCheckoutChecklistListItemSchema.extend(
  {
    checklistItems: z.array(ConsumerCheckoutChecklistItemSchema),
    termPlainText: z.string(),
    photos: z.array(ConsumerCheckoutChecklistPhotoSchema),
    customerDecision: ConsumerCheckoutChecklistDecisionSchema.nullable(),
  },
);
export type ConsumerCheckoutChecklistDetail = z.infer<typeof ConsumerCheckoutChecklistDetailSchema>;

export const ConsumerCheckoutChecklistApproveBodySchema = z.object({
  acceptedTerm: z.literal(true).optional(),
});
export type ConsumerCheckoutChecklistApproveBody = z.infer<
  typeof ConsumerCheckoutChecklistApproveBodySchema
>;

export const ConsumerCheckoutChecklistRejectBodySchema = z.object({
  reason: z.string().trim().min(1).max(500),
});
export type ConsumerCheckoutChecklistRejectBody = z.infer<
  typeof ConsumerCheckoutChecklistRejectBodySchema
>;

export const ConsumerCheckoutChecklistDecisionResponseSchema = z.object({
  serviceOrderId: z.uuid(),
  customerDecision: ConsumerCheckoutChecklistDecisionSchema,
});
export type ConsumerCheckoutChecklistDecisionResponse = z.infer<
  typeof ConsumerCheckoutChecklistDecisionResponseSchema
>;
